// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map__1Bi5g","map__image":"Map_map__image__uZ6aG"};